import { orderBy } from 'lodash';
import moment from 'moment';
import React, { useMemo, useRef, useState } from 'react';

import TabBar from '../../../../../components/TabBar';
import OrderOfPlayCourt from './OrderOfPlayCourt';

const _ = { orderBy };

const OrderOfPlayGridV2 = (props) => {
    const { orderOfPlaySchedule, facilityId, timeZone, date } = props;
    const tabBarRef = useRef(null);

    const [activeCourtIndex, setActiveCourtIndex] = useState(0);

    const handleDrawsTabClick = (ev, i) => {
        setActiveCourtIndex(i);
    };

    const dateDay = moment(date).format('YYYY-MM-DD');
    const timeZoneValue = timeZone?.value || 'UTC';
    const matches = orderOfPlaySchedule?.data?.matches ?? [];

    const scheduleMatches = matches.filter((item) => {
        const details = item.matchDetails;
        if (!details) {
            return false;
        }
        const matchDay = details.date ? moment.utc(details.date).tz(timeZoneValue).format('YYYY-MM-DD') : '';
        if (matchDay !== dateDay) {
            return false;
        }
        if (facilityId && item.facilityId !== facilityId) {
            return false;
        }
        return details?.isDrawPublished !== false;
    });
    const byCourtId = {};
    scheduleMatches.forEach((item) => {
        const { courtId } = item;
        const courtName = item.matchDetails?.courtName ?? '';
        if (!byCourtId[courtId]) {
            byCourtId[courtId] = { id: courtId, name: courtName, matches: [] };
        }

        byCourtId[courtId].matches.push({
            ...item,
        });
    });

    let courts = Object.values(byCourtId).map((court) => {
        court.matches = _.orderBy(court.matches, ['scheduleInfo.sequenceNumber']);
        court.hasMatches = court.matches.length > 0;
        return court;
    });
    courts = _.orderBy(courts.filter(c => c.hasMatches), [c => c.name?.toLowerCase()]);

    const getCourts = () => courts;

    const tabs = useMemo(() => {
        const courtsList = getCourts();
        const visibleCount = Math.min(3, Math.max(1, courtsList.length - activeCourtIndex));
        return courtsList.map((court, i) => {
            const isVisible = i >= activeCourtIndex && i <= activeCourtIndex + 2;
            return {
                title: court.name,
                titleName: court.name,
                showTab: true,
                active: activeCourtIndex === i,
                visible: isVisible,
                visibleIndex: isVisible ? i - activeCourtIndex : undefined,
                visibleCount: isVisible ? visibleCount : undefined,
            };
        });
    }, [activeCourtIndex, orderOfPlaySchedule, facilityId, timeZone, date]);

    return (
        <>
            <TabBar
                tabs={tabs}
                handleTabClick={handleDrawsTabClick}
                ref={tabBarRef}
                eventName="Draws Tab Clicked"
                transparent={true}
                noContainer={true}
                clickCategory="Event Profile"
                clickLocation="Schedule Tab - Courts Tabs"
                data-testid="event-profile.schedule.courts-tab-bar"
            />
            <div className={`container bg-transparent matches`}>
                <div className="row">
                    {getCourts().map((court, i) => {
                        if (i >= activeCourtIndex && i <= activeCourtIndex + 2) {
                            return (
                                <OrderOfPlayCourt
                                    key={court.id}
                                    court={court}
                                    columnNumber={i + 1}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </>
    );
};

export default OrderOfPlayGridV2;
